import { Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle
} from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';

@Component({
  selector: 'app-guidance-box',
  imports: [CdkScrollable, MatDialogTitle, MatDialogContent, MatDialogActions, MatButton, MatDialogClose, MatDivider],
  template: `
    <div mat-dialog-title class="mb-10!">
      <h6>{{ data.title }}</h6>
    </div>
    <div mat-dialog-content class="subtitle-2">
      <div class="my-10 whitespace-pre-wrap">{{ data.alertMessage }}</div>
    </div>
    <mat-divider class="mx-20! mt-10!" />
    <mat-dialog-actions>
      <button matButton="elevated" class="red-button w-100" cdkFocusInitial [mat-dialog-close]="data.confirmButton">
        {{ data.confirmButton }}
      </button>
    </mat-dialog-actions>
  `
})
export class GuidanceBoxComponent {
  data: DialogData = inject(MAT_DIALOG_DATA);
}

export interface DialogData {
  title: string;
  alertMessage: string;
  confirmButton: string;
}
